import type { Components } from "@mui/material";

export const MuiFormLabel: Components["MuiFormLabel"] = {
  styleOverrides: {
    root: {
      color: "#6F7784",
    },
  },
};
